import { FC } from 'react';
import { cn } from '@new/lib';
import { Chat } from '../../types';
import { ChatAvatar } from '../ChatAvatar/ChatAvatar';
import {
  getChatUser,
  getChatUserName,
  getLatestMessage,
  formatMessageTime,
} from '../../lib/helpers';

interface ChatConversationItemProps {
  chat: Chat;
  currentUserId: number;
  isSelected: boolean;
  isUnread: boolean;
  onSelect: (chatId: number) => void;
}

export const ChatConversationItem: FC<ChatConversationItemProps> = ({
  chat,
  currentUserId,
  isSelected,
  isUnread,
  onSelect,
}) => {
  const chatUser = getChatUser(currentUserId, chat.users);
  const chatUserName = getChatUserName(currentUserId, chat.users);
  const latestMessage = getLatestMessage(chat.messages);
  const lastMessage = latestMessage
    ? latestMessage.text.length > 30
      ? `${latestMessage.text.substring(0, 30)}...`
      : latestMessage.text
    : 'No messages yet';
  const lastMessageTime = latestMessage ? formatMessageTime(latestMessage.createdAt) : '';

  return (
    <button
      type="button"
      onClick={() => onSelect(chat.id)}
      className={cn(
        'w-full flex items-center gap-3 p-6 text-left transition-colors cursor-pointer border-none',
        isSelected
          ? 'bg-(--primary-O900)/10 border-r-3 border-r-(--primary-O900)'
          : 'hover:bg-(--neutral-white-NW800)'
      )}
    >
      {/* TODO: Backend doesn't support online status yet - return when backend is ready */}
      {chatUser && <ChatAvatar user={chatUser} size="md" isOnline={false} />}

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span
            className={cn(
              '[font-size:var(--fs-p4)]! truncate',
              isUnread
                ? 'font-bold text-(--neutral-black-NB1000)'
                : 'font-medium text-(--neutral-black-NB900)'
            )}
          >
            {chatUserName}
          </span>
          <span className="[font-size:var(--fs-l6)]! text-(--neutral-black-NB500) flex-shrink-0">
            {lastMessageTime}
          </span>
        </div>
        <div className="flex items-center justify-between gap-2 mt-0.5">
          <p
            className={cn(
              '[font-size:var(--fs-l5)]! truncate m-0!',
              isUnread ? 'text-(--neutral-black-NB800) font-medium' : 'text-(--neutral-black-NB500)'
            )}
          >
            {lastMessage}
          </p>
          {isUnread && (
            <span className="flex-shrink-0 w-2.5 h-2.5 rounded-full bg-(--primary-O900)" />
          )}
        </div>
      </div>
    </button>
  );
};
